import { ReactElement } from 'react';
import dayjs from 'dayjs';
import { DATE_FORMAT } from '@/shared/constants/date';

const MaintenanceDateCell = ({
	maintenanceDate,
}: {
	maintenanceDate?: string | null;
}): ReactElement => {
	if (!maintenanceDate) return <></>;
	return <>{dayjs(maintenanceDate).format(DATE_FORMAT)}</>;
};

export default MaintenanceDateCell;
